<template>
    <p-form @submit="onSubmit">
        <div class="container-fluid content-wrapper" v-if="returnAdjustmentReason">
            <b-row class="content-heading">
                <b-col>
                    <div>{{ isNew ? 'Add' : 'Edit' }} Return Adjustment Reason</div>
                </b-col>
                <b-col cols="auto" class="ms-auto">
                    <p-button type="submit" variant="primary" :is-busy="isBusy"
                        >Save</p-button
                    >
                </b-col>
            </b-row>
            <p-card>
                <b-row cols="1" cols-md="3">
                    <b-col>
                        <p-input
                            label="Adjustment Reason"
                            v-model="returnAdjustmentReason.reason"
                            rules="required|max:100"
                        />
                    </b-col>
                    <b-col>
                        <p-input
                            label="Reason Description"
                            v-model="returnAdjustmentReason.description"
                            rules="max:500"
                        />
                    </b-col> 
                    <b-col>
                        <p-checkbox
                            label="Active"
                            :use-switch="true"
                            v-model="returnAdjustmentReason.isActive"
                            class="mt-3 pt-3 mb-3 pb-3"
                        />
                    </b-col>                                                
                </b-row>
            </p-card>
            <p-feature-flag ref="AccountingFlag" name="Accounting">
                <p-card>
                    <b-row>
                        <b-col>
                            <GLCodeLocation
                                :items="returnAdjustmentReason.locations"
                                :fields="fields"
                                :filterchartofaccounts="filterchartofaccounts" />
                        </b-col>   
                    </b-row>
                </p-card>
            </p-feature-flag>
            <b-row class="mt-3">
                <b-col class="text-start">
                    <p-button
                        variant="outline-danger"
                        type="button"
                        :is-busy="isBusy"
                        @click="deleteReason"
                        v-if="!isNew && !returnAdjustmentReason.isActive"
                        >Delete</p-button
                    >
                </b-col>
                <b-col style="float:left;">
                    <p-button
                        variant="primary"
                        type="submit"
                        :is-busy="isBusy"
                        >Save</p-button
                    >
                </b-col>
            </b-row>
        </div>
    </p-form>
</template>
<script>
    import axios from "axios";
    import NavigationGuard from '@/components/mixins/NavigationGuard.js'
    import editPage from '@/components/mixins/EditPage';
    import GLCodeLocation from '@/components/GLCodeLocation';
    export default {
        mixins: [NavigationGuard, editPage],
        components: {
            GLCodeLocation
        },
        data() {
            return {
                returnAdjustmentReason: null,
                isBusy: false,
                fields:[
                {
                    key: 'locationName',
                    label: 'Location',
                    tdClass: 'reasonLocation'
                },
                {
                    key: 'glCode',
                    label: 'GL Code',
                }
            ]
            };
        },
        watch: {
            returnAdjustmentReason: NavigationGuard.$watcher
        },
        methods: {
            onSubmit() {
                this.isBusy = true;
                axios.post("returnadjustmentreason", this.returnAdjustmentReason)
                    .then((response) => {
                        this.dataSaved();
                        if (this.isNew) {
                            this.$router.push("/returnadjustmentreason/" + response.data);
                        }
                        this.$appSuccess(`Return Adjustment Reason saved successfully.`);
                    })
                    .finally(() => {
                        this.isBusy = false;
                    });
        },
        filterchartofaccounts(chartofaccount) {
            return chartofaccount.type == 'Return Adjustment' || chartofaccount.type == null;        
        },
        loadData() {
            let promise = this.isNew
                ? axios.get('returnadjustmentreason/new')
                : axios.get('returnadjustmentreason', { params: { id: this.id } });
            promise.then(resp => {
                this.returnAdjustmentReason = resp.data;
                this.dataLoaded();                
            });
        },
        deleteReason() {            
                this.isBusy = true;
                axios
                    .post('returnadjustmentreason/delete', this.returnAdjustmentReason)
                    .then(() => {
                        this.dataSaved();
                        this.$router.push('/returnadjustmentreasons');
                        this.$appSuccess(`Return Adjustment Reason deleted successfully.`)
                    })
                    .finally(() => {
                        this.isBusy = false;
                    });
            }
        },
        mounted: function() {
            this.loadData();
        }
    };
</script>
<style scoped lang="scss">
:deep(.reasonLocation ) {
    width:500px;
}
</style>